const FIELD_MAPPING = {
  cash_price: "new_price",
  cash_price_11: "price_11",
  cash_price_05: "price_05",
  cash_price_birthday: "price_birthday",
  cash_price_custom: "price_custom",
  cash_price_wholesale: "price_wholesale",
  debit_price: "new_price_cashless",
  debit_price_11: "price_11_cashless",
  debit_price_05: "price_05_cashless",
  debit_price_birthday: "price_birthday_cashless",
  debit_price_custom: "price_custom_cashless",
  debit_price_wholesale: "price_wholesale_cashless",
  custom_quantity: "quantity_custom",
};

/**
 * Повертає значення поля в залежності від напрямку мапінгу
 * @param {string} fieldName - назва поля
 * @param {string} direction - напрямок мапінгу
 */
const mapField = (fieldName, direction) => {
  if (direction === "toBackend") {
    // Шукаємо fieldName (frontend) як ключ і повертаємо його значення (backend)
    return FIELD_MAPPING[fieldName];
  } else if (direction === "toFrontend") {
    // Шукаємо fieldName (backend) як значення і повертаємо відповідний ключ (frontend)
    for (const frontendKey in FIELD_MAPPING) {
      if (Object.prototype.hasOwnProperty.call(FIELD_MAPPING, frontendKey)) {
        if (FIELD_MAPPING[frontendKey] === fieldName) {
          return frontendKey;
        }
      }
    }
    return undefined; // Якщо бекенд-ключ не знайдено серед значень мапінгу
  }
  return undefined; // Неправильний напрямок
};

export default mapField;
